import React, { Component } from 'react';
import TreeNewTeamDesktop from "views/Tree/TreeNewTeam/TreeNewTeamDesktop";
import TreeNewTeamMobile from "views/Tree/TreeNewTeam/TreeNewTeamMobile";

import { SCREEN_THRESHOLD } from "../../../global/constants";

export default class TreeNewTeam extends Component {

    constructor(props) {
        super(props);
        this.isDesktop = window.innerWidth > SCREEN_THRESHOLD
    }

    addNewTeam = () => {
        this.props.addNewTeam();
    }

    render() {
        return (
            <div>
                {
                    this.isDesktop ?
                        <TreeNewTeamDesktop
                            addNewTeam={() => this.addNewTeam()}
                        />
                        :
                        <TreeNewTeamMobile
                            addNewTeam={() => this.addNewTeam()}
                        />
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Tree/TreeNewTeam/TreeNewTeam.jsx